module.exports = __webpack_public_path__ + "images/5931226ea2684d35963c2c77550f918b.png";